const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';
import Cookiebot from "./Cookiebot.class";
import {iframeResize} from "iframe-resizer"
import PieChartCounter from "./components/PieChartCounter.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #slider;
    #utils;
    #$admin;
    #root;
    #cmp;

    #counter;

    constructor(
        config,
        builder,
        utils,
        slider
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('#site-wrapper');
        this.$header = $('header.elementor-location-header');
        this.#$admin = $('#wpadminbar');
        this.#slider = slider;
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#cmp = new Cookiebot(this.$body);

        $(window).on(this.CMP.events.consent.marketing, () => {
            Utils.log("Showing Pardot Forms...");

            // Link to Pardot iframes
            $(".pardotFormEmbed").each((i, el) => {
                const $el = $(el);
                const utm = this.UTMs;
                const url = $el.data("url") + `&UTM_Campaign=${utm.campaign}&UTM_Source=${utm.source}&UTM_Medium=${utm.medium}&UTM_Content=${utm.content}&UTM_Term=${utm.term}&GCLID=${utm.GCLID}`;

                Utils.log($el);

                if (this.CMP.hasConsent("marketing")) {
                    $el.attr("src", url);
                }

                $el.removeClass("rcioForm__embed--loading");
            });
        });

        new PieChartCounter(this);
    }

    __onReady() {
        const me = this;
        Utils.log("Theme Ready");
        this.#updateCssHeaderHeight();
        // Utils.equalHeight('.kpfsc__post', '.kpf-slider-mode form > .kpfsc__posts');

        // equalHeight kpfsc__post kpfsc__posts.slick-slider

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $(document).on('click', 'a', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (hash === "#open-cmp") {
                    me.CMP.open();
                    e.preventDefault();
                    return false;
                }

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function (i, el) {
            const url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if (url) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                    const id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                    $(el).featherlight();
                }
            }
        });


        $(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $tilescroll = $el.data("tilescroll");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />';
            const $leftArrow = '<i class="fa fas fa-chevron-left" />';
            // $el.css({'visibility': 'visible'});
            let $responsiveTiles;
            switch ($tiles) {
                case 3:
                    $responsiveTiles = 2;
                    break;
                case 2:
                    $responsiveTiles = 2;
                    break;
                case 1:
                    $responsiveTiles = 1;
                    break;
                default:
                    $responsiveTiles = 2;
                    break;
            }

            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: false,
                infinite: true,
                slidesToScroll: $tilescroll,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: $responsiveTiles,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

        let pardotLeadCheck = false;
        window.addEventListener("message", (event) => {

            if (event.origin !== "https://go.partech.com") return;

            let message = false;
            try {
                message = JSON.parse(event.data);
            } catch (e) {
            }

            if (!pardotLeadCheck && message && message.type === "pardot-form-submitted") {
                window.dataLayer = window.dataLayer || [];
                pardotLeadCheck = true;

                setTimeout(() => pardotLeadCheck = false, 10000); // throttle duplicate messages from the same form, not sure why this happens.

                const utm = this.UTMs;

                dataLayer.push({
                    event: 'pardotLead',
                    pardotLead: {
                        pageURL: window.location.origin + window.location.pathname,
                        utm_campaign: utm.campaign,
                        utm_source: utm.source,
                        utm_medium: utm.medium,
                        utm_term: utm.term,
                        utm_content: utm.content,
                        utm_id: utm.id
                    },
                });

                // Allow for external integration
                const event = new CustomEvent("pardot-form-submitted");
                window.dispatchEvent(event);

                if (message.formID) {
                    const $form = $(`.pardotFormEmbed[data-id="${message.formID}"]`);
                    const resource = $form.data("resource");

                    if (resource) {
                        $(window).trigger('rcio_form_submitted', [message.email, resource, function (response) {
                            $(`.rcioForm__message[data-formid="${message.formID}"]`).html(response);
                        }]);
                    }
                }
            }
        });

        setTimeout(function () {
            const frame = iframeResize({
                log: Utils.debug,
                scrolling: false,
                checkOrigin: false
            }, ".pardotFormEmbed, .embedded-form iframe");
            setInterval(frame.resize, 1000);
        }, 1);

        $(".rcioFilterBar__filter select[name='resource-location']").on('change', function () {
            window.location.href = $(this).val();
        });

        this.#setupSearch();

        var $components = $(".elementor-widget-ticker-counter-wrap");
        const options = {
            root: null,
            rootMargin: "0px",
            scrollMargin: "-30% 0px -30% 0px",
            threshold: 1.0,
        };

        const animatePicker = function (entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    let el = entry.target;
                    if (entry.intersectionRatio >= 0.75) {
                        $(el).trigger("builderAnimationStart", [el]);
                    }
                }
            });

        }

        const observer = new IntersectionObserver((entries, observer) => animatePicker(entries, observer), options);

        $components.each(function (i, el) {
            observer.observe(el);
        });


    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");

        this.#updateCssHeaderHeight();

        this.$header.addClass('fixed');
        $(window).trigger("resize");

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        const top = 1; // Trigger on any scrolling
        $(document).scroll(function () {
            const scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.elementor-location-header').addClass('scrolled');
            } else if (top && scrollPos < top) {
                $('.elementor-location-header').removeClass('scrolled');
            }
        });


        // var menu = new window.Mmenu("#menu-wrapper", {
        //     "offCanvas": {
        //         "position": "right-front",
        //     },
        // }, {
        //     "offCanvas": {
        //         "page": {
        //             "selector": "#site-wrapper"
        //         }
        //     }
        // });
        //
        // $('.mmenu-nav').on('click', function (evnt) {
        //     evnt.preventDefault();
        //     menu.API.open()
        // })


        // Re-enable when mobile menu is setup.
        // var menu = new window.Mmenu("#menu-wrapper", {
        //     "offCanvas": {
        //         "position": "right-front"
        //     },
        //     "theme": "dark",
        //     "counters": {
        //         "add": true
        //     },
        //     "iconbar": {
        //         "use": true,
        //         "top": [
        //             "<a href='#/'><i class='fa fa-home'></i></a>",
        //             "<a href='#/'><i class='fa fa-user'></i></a>"
        //         ],
        //         "bottom": [
        //             "<a href='#/'><i class='fa fa-twitter'></i></a>",
        //             "<a href='#/'><i class='fa fa-facebook'></i></a>",
        //             "<a href='#/'><i class='fa fa-linkedin'></i></a>"
        //         ]
        //     },
        //     "iconPanels": {
        //         "add": true,
        //         "visible": 1
        //     },
        //     "navbars": [
        //         {
        //             "position": "top",
        //             "content": [
        //                 "searchfield"
        //             ]
        //         },
        //         {
        //             "position": "bottom",
        //             "content": [
        //                 "<a class='fa fa-envelope' href='#/'></a>",
        //                 "<a class='fa fa-twitter' href='#/'></a>",
        //                 "<a class='fa fa-facebook' href='#/'></a>"
        //             ]
        //         }
        //     ]
        // }, {
        //     "offCanvas": {
        //         "page": {
        //             "selector": "#site-wrapper"
        //         }
        //     }
        // });
        //
        // $('.mmenu-nav').on('click', function (evnt) {
        //     evnt.preventDefault();
        //     menu.API.open()
        // })

        //Preserve UTM codes across site browsing
        let utmParams = {};
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        let utmString = '';
        utmKeys.forEach(key => {
            if (Utils.URLSearchParams.has(key)) {
                utmParams[key] = encodeURIComponent(Utils.URLSearchParams.get(key) || "");
                utmString += `&${key}=${utmParams[key]}`;
            }
        });

        if (Object.keys(utmParams).length > 0) {
            $("a").each(function (e) {
                let $el = $(this);
                if (location.host === $el[0].host && $el[0].hash === '') {
                    if ($el[0].search) {
                        $el.attr("href", `${$el.attr('href')}${utmString}`);
                    } else {
                        $el.attr("href", `${$el.attr('href')}${utmString.replace('&', '?')}`);
                    }
                }
            });
        }

        // Fix SVG's with embedded clip-paths
        $("svg").each(function (i, el) {
            const $el = $(el);
            const $parent = $el.closest(".elementor-widget");
            let pathIDs = [];
            const suffix = $parent.data("id");
            const instance = i;

            $el.find("clipPath").each((i, el) => {
                const $cp = $(el);
                let id = $cp.attr("id");
                pathIDs.push(id);
                $cp.attr("id", `${id}-${suffix}-${instance}`);
            });

            pathIDs.forEach((val, key) => {
                $el.find(`[clip-path="url(#${val})"]`).each((i, el) => {
                    const $cpEL = $(el);
                    $cpEL.attr("clip-path", `url(#${val}-${suffix}-${instance})`);
                });
            });
        });

        $('.js--hide-while-loading').removeClass('js--hide-while-loading');
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    /**
     * @param {PostFilters} kpf
     * @public
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");
        kpf.addFilter('post_transition_delay', () => 0)

    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #setupSearch() {
        function toggleClassForEls(els, theClass) {
            els.forEach((item) => {
                item.classList.toggle(theClass);
            });
        }

        const searchIcon = document.querySelectorAll('.search-menu-icon');
        const searchIconClose = document.querySelectorAll('.search-menu-icon-close');
        const searchBox = document.querySelector('#search-menu-box');

        searchIcon.forEach((item) => {
            item.addEventListener('click', () => {
                const mobileToggle = document.querySelector('.mobile-menu .elementor-menu-toggle')

                if (mobileToggle && mobileToggle.classList.contains('elementor-active')) {
                    document.querySelector('.mobile-menu .elementor-menu-toggle').click();
                }

                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').focus();
            })
        });

        searchIconClose.forEach((item) => {
            item.addEventListener('click', () => {
                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').blur();
            })
        });
    }

    get CMP() {
        return this.#cmp;
    }

    get UTMs() {
        return {
            id: encodeURIComponent(Utils.URLSearchParams.get('utm_id') || ""),
            campaign: encodeURIComponent(Utils.URLSearchParams.get('utm_campaign') || ""),
            source: encodeURIComponent(Utils.URLSearchParams.get('utm_source') || ""),
            medium: encodeURIComponent(Utils.URLSearchParams.get('utm_medium') || ""),
            term: encodeURIComponent(Utils.URLSearchParams.get('utm_term') || ""),
            content: encodeURIComponent(Utils.URLSearchParams.get('utm_content') || ""),
            GCLID: encodeURIComponent(Cookies.get("gclid") || "")
        };
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}